import { compare } from 'compare-versions';
import { useAppSelector } from '../state';
import { selectSdk, selectSdkVersion, selectFeatureFlags, selectDevicePlatform, } from '../state/slices/slice-link-params';
import { getSemverString } from '../utils';
export var useAreScreenshotsEnabled = function () {
    var sdk = useAppSelector(selectSdk);
    var devicePlatform = useAppSelector(selectDevicePlatform);
    var featureFlags = useAppSelector(selectFeatureFlags);
    var sdkVersion = getSemverString(useAppSelector(selectSdkVersion));
    if (!featureFlags.nativeLinkScreenshots || !sdkVersion || !sdk) {
        return false;
    }
    var isAndroidCompatible = sdk === 'android' && compare(sdkVersion, '3.1.3', '>=');
    var isIosCompatible = sdk === 'ios' && compare(sdkVersion, '3.1.1', '>=');
    var isRnCompatible = sdk === 'react native' &&
        (devicePlatform === 'android'
            ? compare(sdkVersion, '3.2.5', '>=')
            : devicePlatform === 'ios'
                ? compare(sdkVersion, '3.1.1', '>=')
                : false);
    return isAndroidCompatible || isIosCompatible || isRnCompatible;
};
